import {
  generateTipTapText,
  TipTapContentRequired,
  tipTapBaseExtensions,
  fillInTheBlanksBaseExtensionConfig,
  TipTapNode,
} from '@lessonup/pins-shared';
import { compact, trim } from 'lodash';

export const fillInTheBlanksExtension = TipTapNode.create({
  ...fillInTheBlanksBaseExtensionConfig,
});

export const fillInTheBlanksViewerExtensions = compact([...tipTapBaseExtensions, fillInTheBlanksExtension]);

export namespace FillInTheBlanks {
  export const type = 'fillInTheBlanks';

  export type AnswerResult = {
    type: 'correct' | 'incorrect' | 'noAnswer';
    answerResults: {
      correctAnswer: string;
      isCorrect: boolean | null;
    }[];
  };

  export interface Answer {
    answers: (string | null)[];
    modifiedAt: number;
  }

  export namespace Answer {
    export function resultForAnswer(answers: (string | null)[], correctAnswer: TipTapContentRequired[]): AnswerResult {
      const answerResults = answers.map((answer, index) => {
        const correctAnswerAsString = generateTipTapText(correctAnswer[index], fillInTheBlanksViewerExtensions);
        const answerIsCorrect = trim(answer?.toLowerCase()) === trim(correctAnswerAsString.toLowerCase());

        return {
          correctAnswer: correctAnswerAsString,
          isCorrect: answerIsCorrect,
        };
      });

      const isCorrect = answerResults.every((result) => result.isCorrect);
      const hasAnswer = answers.some((answer) => answer !== null);

      const type = hasAnswer ? (isCorrect ? 'correct' : 'incorrect') : 'noAnswer';
      return { answerResults, type };
    }
  }
}
